import React from 'react';
import {Checkbox, Select, Switch} from "antd";

const FaceParameters = () => {
    const onChange = (v) => {

    }
    return (
        <div className="ip-settings equipment-maintenance main-padding">
            <div className="camera-config-header">
                <span>Home</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>System Management</span>
                <img src="/icon/arrowleft.svg" alt=">"/>
                <span>Face Parameters</span>
            </div>

            <div className="camera-config-content">
                <div className="my-avform ">
                    <div className="row ">
                        <div className="col-md-2 text-end">
                            <label className="text-white">
                                Live Detection Mode
                            </label>
                        </div>
                        <div className="col-md-4">
                            <Select

                                placeholder="Поиск, чтобы выбрать"
                                optionFilterProp="children"
                                className="w-100"

                            >
                                <option value="1">asd</option>
                                <option value="3">asd</option>
                                <option value="2">asd</option>
                            </Select>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Living Threshold
                        </div>
                        <div className="col-md-4">
                            <div className="number-counter">
                                <span className="minus">-</span>
                                <input type="text" value="1"/>
                                <span className="plus">+</span>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-2 text-end">
                            <label className="text-white">
                                Exposure Mode
                            </label>
                        </div>
                        <div className="col-md-4">
                            <Select

                                placeholder="Поиск, чтобы выбрать"
                                optionFilterProp="children"
                                className="w-100"

                            >
                                <option value="1">asd</option>
                                <option value="3">asd</option>
                                <option value="2">asd</option>
                            </Select>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end">
                            <label className="text-white">
                                Capture Mode
                            </label>
                        </div>
                        <div className="col-md-4">
                            <Select

                                placeholder="Поиск, чтобы выбрать"
                                optionFilterProp="children"
                                className="w-100"

                            >
                                <option value="1">asd</option>
                                <option value="3">asd</option>
                                <option value="2">asd</option>
                            </Select>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end">
                            <label className="text-white">
                                Local Image Save Mode
                            </label>
                        </div>
                        <div className="col-md-4">
                            <Select

                                placeholder="Поиск, чтобы выбрать"
                                optionFilterProp="children"
                                className="w-100"

                            >
                                <option value="1">asd</option>
                                <option value="3">asd</option>
                                <option value="2">asd</option>
                            </Select>
                        </div>
                    </div>
                    <div className="row  align-items-center mt-3">
                        <label className="col-md-2 text-end cmcf-title">Image Upload Mode</label>
                        <div className="col-md-8">
                            <Checkbox onChange={onChange} className="mr-16">Face Image</Checkbox>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Humanoid Coding Quality</div>
                        <div className="col-md-4">
                            <div className="number-counter">
                                <span className="minus">-</span>
                                <input type="text" value="1"/>
                                <span className="plus">+</span>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Humanoid Expansion Factor</div>
                        <div className="col-md-4">
                            <div className="number-counter">
                                <span className="minus">-</span>
                                <input type="text" value="1"/>
                                <span className="plus">+</span>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Turn On FaceBox</div>
                        <div className="col-md-4"><Switch defaultChecked onChange={onChange}/></div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Face Image Expansion Factor</div>
                        <div className="col-md-2">
                            <div className="number-counter">
                                <span className="minus">-</span>
                                <input type="text" value="1"/>
                                <span className="plus">+</span>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Face Sensitivity</div>
                        <div className="col-md-2">
                            <div className="number-counter">
                                <span className="minus">-</span>
                                <input type="text" value="1"/>
                                <span className="plus">+</span>
                            </div>
                        </div>
                        <div className="col-md-3  text-white"> (The lower the value, the more sensitive)</div>

                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Face Quality</div>
                        <div className="col-md-2">
                            <div className="number-counter">
                                <span className="minus">-</span>
                                <input type="text" value="1"/>
                                <span className="plus">+</span>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Scene quality</div>
                        <div className="col-md-2">
                            <div className="number-counter">
                                <span className="minus">-</span>
                                <input type="text" value="1"/>
                                <span className="plus">+</span>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Max Pixel Of Face</div>
                        <div className="col-md-2">
                            <div className="number-counter">
                                <span className="minus">-</span>
                                <input type="text" value="1"/>
                                <span className="plus">+</span>
                            </div>
                        </div>
                        <div className="col-md-2 text-white">(300 ~ 700)</div>

                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Minimum Pixel Of Face</div>
                        <div className="col-md-2">
                            <div className="number-counter">
                                <span className="minus">-</span>
                                <input type="text" value="1"/>
                                <span className="plus">+</span>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Face Property Detection</div>
                        <div className="col-md-4"><Switch defaultChecked onChange={onChange}/></div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Selection Mode <button className="text-primary bg-transparent border-0">Quality</button></div>
                        <div className="col-md-4"><Switch defaultChecked onChange={onChange}/>  <button className="text-primary bg-transparent ml-8 border-0">Point</button></div>


                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Angle Of Face Left And Right
                        </div>
                        <div className="col-md-2">
                            <div className="number-counter">
                                <span className="minus">-</span>
                                <input type="text" value="1"/>
                                <span className="plus">+</span>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Face Elevation Angle
                        </div>
                        <div className="col-md-2">
                            <div className="number-counter">
                                <span className="minus">-</span>
                                <input type="text" value="1"/>
                                <span className="plus">+</span>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 text-end text-white">Face Head Crooked Roll Angle
                        </div>
                        <div className="col-md-2">
                            <div className="number-counter">
                                <span className="minus">-</span>
                                <input type="text" value="1"/>
                                <span className="plus">+</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="offset-2 col-md-4 mt-3">
                    <button className="btn btn-primary">SET</button>
                </div>
            </div>
        </div>
    );
};

export default FaceParameters;